// @flows
import MonthDailyPeriods from './MonthDailyPeriods';

export default MonthDailyPeriods;
